import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInput, TextInputProps } from '@any-ui-react/core';

import { AddressPart } from '@anyx/shared-utils';

import { useAddressFormContext } from '../context';

export type CompanyFieldProps = Partial<TextInputProps>;

export const CompanyField = ({ ...rest }: CompanyFieldProps) => {
  const { t } = useTranslation('shared');
  const { register, getFieldState } = useFormContext();
  const { mappings } = useAddressFormContext();

  const fieldName = mappings[AddressPart.COMPANY];
  if (!fieldName) {
    return;
  }

  return (
    <TextInput
      {...register(fieldName)}
      label={t('shared.field.company.name', { ns: 'shared' })}
      placeholder={t('shared.field.company.placeholder', { ns: 'shared' })}
      error={getFieldState(fieldName)?.error?.message?.toString()}
      {...rest}
    />
  );
};
